
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benefits-guide/[uid]",
      function () {
        return require("private-next-pages/benefits-guide/[uid].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/benefits-guide/[uid]"])
      });
    }
  